"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONNECTIONS_PROPERTIES = exports.ALWAYS_EDITABLE_PROPERTIES = exports.EditablePropertiesEnum = void 0;
var EditablePropertiesEnum;
(function (EditablePropertiesEnum) {
    EditablePropertiesEnum["PRICE"] = "price";
    EditablePropertiesEnum["TITLE"] = "title";
    EditablePropertiesEnum["SUBTITLE"] = "subtitle";
    EditablePropertiesEnum["TAX_PERCENTAGE"] = "tax_percentage";
    EditablePropertiesEnum["IS_ARCHIVED"] = "isArchived";
    EditablePropertiesEnum["IS_AVAILABLE"] = "isAvailable";
    EditablePropertiesEnum["IS_ORDERABLE"] = "isOrderable";
    EditablePropertiesEnum["SHOW_ORDER"] = "metadata.show_order";
    EditablePropertiesEnum["METADATA_CRITERIA"] = "metadata.criteria";
    EditablePropertiesEnum["EXTERNAL_IMAGE_URL"] = "externalImageUrl";
    EditablePropertiesEnum["PROPERTIES"] = "properties";
    EditablePropertiesEnum["MODIFIER_GROUPS"] = "modifierGroups";
    EditablePropertiesEnum["METADATA_CATEGORIES"] = "metadata.categories";
    EditablePropertiesEnum["ITEM_SETS"] = "itemSet";
    EditablePropertiesEnum["METADATA_SELECTIONS"] = "metadata.selections";
    EditablePropertiesEnum["SKU"] = "sku";
})(EditablePropertiesEnum = exports.EditablePropertiesEnum || (exports.EditablePropertiesEnum = {}));
exports.ALWAYS_EDITABLE_PROPERTIES = [
    EditablePropertiesEnum.TAX_PERCENTAGE,
    EditablePropertiesEnum.SHOW_ORDER,
    EditablePropertiesEnum.METADATA_CRITERIA,
    EditablePropertiesEnum.IS_AVAILABLE,
];
exports.CONNECTIONS_PROPERTIES = [
    EditablePropertiesEnum.PROPERTIES,
    EditablePropertiesEnum.MODIFIER_GROUPS,
    EditablePropertiesEnum.METADATA_CATEGORIES,
    EditablePropertiesEnum.ITEM_SETS,
    EditablePropertiesEnum.METADATA_SELECTIONS,
];
//# sourceMappingURL=EditablePropertiesEnum.js.map